import { Tooltip } from '@mui/material';
import { HelpOutline as HelpIcon } from '@mui/icons-material';

interface SummaryTabProps {
  label: string;
  count: number;
  dotClass: string;
  badgeClass: string;
  explanation: string;
  isActive: boolean;
  onClick: () => void;
}

const SummaryTab = ({
  label,
  count,
  dotClass,
  badgeClass,
  explanation,
  isActive,
  onClick,
}: SummaryTabProps) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`
        relative flex items-center gap-3 min-h-[60px] px-5 transition-all duration-500 outline-none
        rounded-t-[20px] border-x border-t cursor-pointer
        ${
          isActive
            ? 'bg-white border-[#e2e8f0] border-b-white translate-y-[1px] z-10'
            : 'bg-[#f1f5f9] border-transparent border-b-[#e2e8f0] hover:bg-[#eaf2f9] z-0'
        }
      `}
    >
      <Tooltip 
        title={explanation} 
        arrow 
        placement='top'
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: '13px',
              padding: '10px 14px',
              backgroundColor: 'rgba(51, 65, 85, 0.95)',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
            }
          },
          arrow: {
            sx: {
              color: 'rgba(51, 65, 85, 0.95)'
            }
          }
        }}
      >
        <div className='absolute top-1 right-1.5'>
          <HelpIcon
            sx={{ 
              fontSize: 20,
              color: isActive ? '#64748b' : '#94a3b8',
              opacity: isActive ? 1 : 0.7,
              '&:hover': {
                color: '#475569',
                opacity: 1
              }
            }} 
          />
        </div>
      </Tooltip>

      <div
        className={`w-2 h-2 rounded-full flex-shrink-0 ${dotClass}`}
      />

      <span
        className={`
        font-black uppercase tracking-widest text-[11px] whitespace-nowrap
        ${isActive ? 'text-slate-800' : 'text-slate-400'}
      `}
      >
        {label}
      </span>

      <div
        className={`
        px-2.5 h-[22px] flex items-center justify-center rounded-lg text-[11px] font-black min-w-[32px]
        ${isActive ? badgeClass : 'bg-[#e2e8f0] text-[#94a3b8]'}
      `}
      >
        {count}
      </div>
    </button>
  );
};

export default SummaryTab;
